import StartupType from './StartupType'

const startupReducer = (state, action) => {
  switch (action.type) {
    case StartupType.GET_STARTUPS:
      return {
        ...state,
        startups: action.payload,
        loading: false,
      }
    case StartupType.GET_STARTUP:
      return {
        ...state,
        startup: action.payload,
        loading: false,
      }
    case StartupType.CREATE_STARTUP:
      return {
        ...state,
        product: action.payload,
        loading: false,
      }
    case StartupType.UPDATE_STARTUP:
      return {
        ...state,
        product: action.payload,
        loading: false,
      }
    case StartupType.GET_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
        loading: false,
      }
    case StartupType.GET_PHASE_OPERATIONS:
      return {
        ...state,
        phaseOperations: action.payload,
        loading: false,
      }
    case StartupType.GET_PROVINCES:
      return {
        ...state,
        provinces: action.payload,
        loading: false,
      }
    case StartupType.GET_PROVINCE:
      return {
        ...state,
        cities: action.payload.cities,
        loading: false,
      }
    case StartupType.CREATE_TICKET:
      return {
        ...state,
        ticket: action.payload,
        loading: false,
      }
    case StartupType.UPLOAD_FILE:
      return {
        ...state,
        file: action.payload,
        loading: false,
        uploading: false,
      }
    case StartupType.GET_ROUNDS:
      return {
        ...state,
        rounds: action.payload,
        loading: false,
      }
    case StartupType.UPDATE_ROUND:
      return {
        ...state,
        round: action.payload,
        loading: false,
      }
    case StartupType.VALUATION_STARTUP:
      return {
        ...state,
        loading: false,
      }
    case StartupType.GET_CITIES_BY_PROVINCE_ID:
      return {
        ...state,
        cities: action.payload,
        loading: false,
      }
    case StartupType.GET_STARTUP_MANAGERS:
      return {
        ...state,
        admins: action.payload,
        loading: false,
      }
    case StartupType.GET_INVESTOR_MANAGERS:
      return {
        ...state,
        admins: action.payload,
        loading: false,
      }
    case StartupType.GET_COMPANY_PROJECTS:
      return {
        ...state,
        projectIds: action.payload,
        loading: false,
      }
    case StartupType.GET_STARTUP_INFO:
      return {
        ...state,
        startupInfo: action.payload,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default startupReducer
